// SubscriptionSection.js
import React, { useEffect, useState } from 'react';
import axiosInstance from '../axiosConfig';
// import './Subscription.css'; // Optional: add styling as needed

const SubscriptionSection = () => {
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [portalLoading, setPortalLoading] = useState(false);
  const [error, setError] = useState('');
  const [cancelMessage, setCancelMessage] = useState('');

  // Fetch subscription status on component mount
  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      try {
        const response = await axiosInstance.get('/check-subscription-status/');
        setSubscriptionData(response.data);
      } catch (err) {
        console.error('Error fetching subscription details:', err);
        setError('Failed to fetch subscription details');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionStatus();
  }, []);

  // Handler to cancel the subscription with confirmation popup
  const handleCancelSubscription = async () => {
    const confirmCancel = window.confirm(
      'Are you sure you want to cancel your subscription? This will cancel your subscription at the end of your billing period.'
    );
    if (!confirmCancel) {
      return;
    }

    setCancelLoading(true);
    try {
      const response = await axiosInstance.post('/cancel-subscription/');
      setCancelMessage(response.data.message || 'Cancellation initiated');
      // Optionally, refresh the subscription data after cancellation
      const updatedStatus = await axiosInstance.get('/check-subscription-status/');
      setSubscriptionData(updatedStatus.data);
    } catch (err) {
      console.error('Error cancelling subscription:', err);
      setError('Error cancelling subscription');
    } finally {
      setCancelLoading(false);
    }
  };

  // Handler to open Stripe billing portal for managing membership
  const handleManageMembership = async () => {
    setPortalLoading(true);
    try {
      const response = await axiosInstance.post('/subscription-portal/');
      const { portal_url } = response.data;
      if (portal_url) {
        window.open(portal_url, '_blank');
      }
    } catch (err) {
      console.error('Error opening billing portal:', err);
      setError('Unable to open billing portal. Please try again.');
    } finally {
      setPortalLoading(false);
    }
  };

  if (loading) return <p>Loading subscription details...</p>;
  if (error) return <p className="error">{error}</p>;

  const { subscription_details: details } = subscriptionData;
  const isSubscribed = subscriptionData.is_subscribed;

  return (
    <div className="subscription-section">
      <h3>Your Membership</h3>
      {isSubscribed ? (
        <div>
          <p><strong>Status:</strong> <span className="capitalize">{details.status}</span></p>
          <p><strong>Billing Cycle:</strong> <span className="capitalize">{details.billing_cycle || 'N/A'}</span></p>
          <p>
          <strong>Monthly Rate:</strong>{' '}
            {details.monthly_rate ? `$${details.monthly_rate}` : 'N/A'}
          </p>
          <p>
            <strong>Next Payment Date:</strong>{' '}
            {details.next_payment_date
              ? new Date(details.next_payment_date).toLocaleDateString()
              : 'N/A'}
          </p>
          <p>
            <strong>Cancel at Period End:</strong>{' '}
            {details.cancel_at_period_end ? 'Yes' : 'No'}
          </p>
          <div className="membership-buttons">
            <button
              className="manage-membership-btn"
              onClick={handleManageMembership}
              disabled={portalLoading}
            >
              {portalLoading ? 'Opening...' : 'Manage Membership'}
            </button>
            {/* Show cancel button only if the subscription is active and not already marked for cancellation */}
            {(!details.cancel_at_period_end) && (
              <button
                className="cancel-membership-btn"
                onClick={handleCancelSubscription}
                disabled={cancelLoading}
              >
                {cancelLoading ? 'Cancelling...' : 'Cancel Membership'}
              </button>
            )}
          </div>
          {cancelMessage && <p className="message">{cancelMessage}</p>}
        </div>
      ) : (
        <p>You do not have an active subscription.</p>
      )}
    </div>
  );
};

export default SubscriptionSection;
